import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LocationContext } from '../App';

const FeaturedSections = () => {
  const { userLocation } = useContext(LocationContext);
  
  // Define sections by location
  const sectionsByLocation = {
    US: [
      {
        id: 'sat',
        title: 'SAT Preparation',
        description: 'Comprehensive practice for the Scholastic Assessment Test',
        icon: '📚',
        color: '#3498db',
        url: '/comingsoon',
        count: 'Coming Soon',
        disabled: true
      },
      {
        id: 'act',
        title: 'ACT Practice',
        description: 'Master the American College Testing exam',
        icon: '✏️',
        color: '#2ecc71',
        url: '/comingsoon',
        count: 'Coming Soon',
        disabled: true
      },
      {
        id: 'quantitative-aptitude',
        title: 'Quantitative Aptitude',
        description: 'Master numerical skills with our comprehensive aptitude tests',
        icon: '🧮',
        color: '#9b59b6',
        url: '/quantitative-aptitude-questions',
        count: '1000+ questions'
      }
    ],
    IN: [
      {
        id: 'quantitative-aptitude',
        title: 'Quantitative Aptitude',
        description: 'Master numerical skills for competitive exams in India',
        icon: '🧮',
        color: '#3498db',
        url: '/quantitative-aptitude-questions',
        count: '1000+ questions'
      },
      {
        id: 'ssc',
        title: 'SSC Exams',
        description: 'Prepare for Staff Selection Commission exams',
        icon: '🏛️',
        color: '#e74c3c',
        url: '/comingsoon',
        count: 'Coming Soon',
        disabled: true
      },
      {
        id: 'bank',
        title: 'Bank Exams',
        description: 'Practice for IBPS, SBI and other banking exams',
        icon: '🏦',
        color: '#2ecc71',
        url: '/comingsoon',
      count: 'Coming Soon',
        disabled: true
      }
    ]
  };
  
  // Add a default set of sections for other locations
  sectionsByLocation.default = [
    {
      id: 'quantitative-aptitude',
      title: 'Quantitative Aptitude',
      description: 'Master numerical skills with our comprehensive aptitude tests',
      icon: '🧮',
      color: '#3498db',
      url: '/quantitative-aptitude-questions',
      count: '1000+ questions'
    },
    {
      id: 'verbal-ability',
      title: 'Verbal Ability',
      description: 'Enhance your language and comprehension skills',
      icon: '📝',
      color: '#e74c3c',
      url: '/comingsoon',
      count: 'Coming Soon',
      disabled: true
    },
    {
      id: 'logical-reasoning',
      title: 'Logical Reasoning',
      description: 'Sharpen your analytical and problem-solving abilities',
      icon: '🧩',
      color: '#2ecc71',
      url: '/comingsoon',
      count: 'Coming Soon',
      disabled: true
    }
  ];
  
  // Get sections for current location or use default
  const sections = sectionsByLocation[userLocation] || sectionsByLocation.default;

  return (
    <div style={{ margin: '30px auto', maxWidth: '1000px' }}>
      <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '20px', fontSize: '24px' }}>
        Featured Learning Paths for {userLocation === 'US' ? 'United States' : userLocation === 'IN' ? 'India' : 'Your Region'}
      </h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
        {sections.map(section => (
          <Link 
            key={section.id}
            to={section.url}
            style={{ 
              textDecoration: 'none',
              flex: '1 1 300px',
              maxWidth: '400px',
              background: section.disabled 
                ? 'linear-gradient(135deg, #95a5a6, #7f8c8d)'
                : `linear-gradient(135deg, ${section.color}, ${section.color}dd)`,
              borderRadius: '12px',
              padding: '25px',
              color: 'white',
              boxShadow: `0 8px 20px ${section.disabled ? '#95a5a633' : `${section.color}33`}`,
              transition: 'transform 0.3s, box-shadow 0.3s',
              position: 'relative',
              overflow: 'hidden',
              cursor: section.disabled ? 'default' : 'pointer',
            }}
            className="featured-section-card"
            onClick={e => section.disabled && e.preventDefault()}
            onMouseEnter={e => {
              if (!section.disabled) {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = `0 12px 25px ${section.color}40`;
              }
            }}
            onMouseLeave={e => {
              if (!section.disabled) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = `0 8px 20px ${section.color}33`;
              }
            }}
          >
            <div style={{ fontSize: '40px', marginBottom: '15px' }}>{section.icon}</div>
            <h3 style={{ fontSize: '22px', marginBottom: '10px' }}>{section.title}</h3>
            <p style={{ opacity: 0.9, marginBottom: '15px' }}>{section.description}</p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span>{section.count}</span>
              {!section.disabled && <span style={{ fontSize: '24px' }}>→</span>}
            </div>
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.1)',
              zIndex: 0
            }}></div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FeaturedSections;
